import { get, put } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

export function updateOfferPartnerEligibility(eligibility) {
  return put(url + `/leasingdocument/${eligibility.documentId}/${eligibility.siteId}/partnerteligibility`, eligibility);
}

export function getPartnerEligibility(documentId, siteId, partnerId) {
  return get(`${url}/leasingdocument/${documentId}/${siteId}/partnerteligibility/${partnerId}`);
}
